// API End Points
import {
  getGamListEndpoint,
  getGamDetailsEndpoint,
  getGamInfoForInvoiceNo,
  initiateAutoGamCreate,
} from "@/config/apiEndPoints";
// Constants
import {
  APIGEE_CLIENT_KEY_ACCOUNT,
  APIGEE_CLIENT_KEY_DISPUTE,
} from "@/config/constant";
const fetchGamDetailsByInvoiceNumber = (invoiceNumber, idToken) => {
  return {
    method: "post",
    url: getGamListEndpoint(0, 30),
    data: {
      filters: [],
      object_id: "gam-task",
      search: invoiceNumber,
      sort_by: "created_timestamp",
      sort_order: "DESC",
    },
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};
const fetchGamDetailsByGamId = (gamId, gamType, idToken) => {
  return {
    method: "get",
    url: getGamDetailsEndpoint(gamId, gamType),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const getGamInfoForInvoiceNumber = (invoiceNumber, idToken) => {
  return {
    method: "get",
    url: getGamInfoForInvoiceNo(0, 30, invoiceNumber),
    headers: {
      Authorization: idToken,
      "Consumer-Key": APIGEE_CLIENT_KEY_ACCOUNT,
    },
  };
};

const initiateAutoGamCreateFlow = (data, idToken) => {
  return {
    method: "post",
    url: initiateAutoGamCreate(),
    headers: {
      Authorization: `${idToken}`,
    },
    data,
  };
};

export default {
  fetchGamDetailsByGamId,
  fetchGamDetailsByInvoiceNumber,
  getGamInfoForInvoiceNumber,
  initiateAutoGamCreateFlow,
};
